<template>
    <div id="DealerFacilitySetting">
        <div id="container">
            <template v-if="from !='control'">
                <masterNavi v-bind:pageid='"UserManage"'></masterNavi>
                <div class="labelTitle lable">ユーザー管理</div>
                <userNavi v-bind:pageid='"ExternalUserSearch"'></userNavi>
            </template>
            <div class="labelTitle lable">施設別見積り情報</div>
            <template v-if="!facilityList">
            </template>
            <template v-else-if="facilityList.length == 0">
                <div class="button-area">
                    <span>施設が登録されていません。</span>
                    <b-button class="backButton is-primary" @click="back">戻る</b-button>
                </div>          
            </template>
            <template v-else>
                <div class="button-area">
                    <b-button
                        class="postion-left is-primary"                
                        icon-left="chevron-double-left"
                        @click.prevent="Backward">前の施設へ
                    </b-button>
                    <select @change="chengeSelect" v-model="selectedFacility" class="selectFacility" id="selectFacility">
                        <option v-for="(item, index) of facilityList" :key="index" :value="item">{{item.facilityName}}<span v-if="item.office">（{{item.office| officeFilter(branchList)}}）</span></option>
                    </select>
                    <b-button
                        class="postion-left is-primary"
                        icon-right="chevron-double-right"
                        @click.prevent="Forward">次の施設へ
                    </b-button>
                    <b-button class="backButton is-primary" @click="back">戻る</b-button>
                </div>
                <div v-if="data" id="item-contens" class="judgment-area">
                    <div class="card-content margin-top">
                        <span style="font-size:20px; word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.facilityName}}</span>
                        <div class="officeArea">
                          <table id="officeAreaTable">
                            <tr>
                              <td colspan="4" style="color:red;text-align:center;">変更があった場合はページごとに必ず更新を押してください。</td>
                            </tr>
                            <tr>
                              <th >施設ID</th>
                              <td>{{selectedFacility.facilityId}}</td>
                            </tr>
                            <tr>
                              <th>担当支店<span class="require"/></th>
                              <td>
                                <select v-model="data.office" @change="changeSalesOffice">
                                  <option value=""></option><option v-for="branch in branchList" :value="branch.code" :key="branch.code">{{ branch.name }}</option>
                                </select>
                              </td>
                              <th>担当営業所(売上)<span class="require"/></th>
                              <td>
                                <select v-model="data.salesOfficeCode" >
                                  <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                                    {{office.name}}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <th >得意先名称<span class="require"/></th>
                              <td colspan="3">
                                <input type="text" class="officeAreaTableInputLong" :value="getName(data.medicalInstitutionName,data.medicalInstitutionCode)" disabled/>
                                <b-button class="is-primary withButton" v-on:click="customerModalActive=true">得意先選択</b-button>
                              </td>
                            </tr>
                            <tr>
                              <template v-if="billingEnabled">
                                <th >請求先名称</th>
                                <td colspan="3">
                                  <input type="text" class="officeAreaTableInputLong" :value="getName(data.billingName, data.billingCode)" disabled placeholder="※得意先IDと異なるコードに売上を計上する場合は指定してください"/>
                                  <b-button class="is-primary withButton" v-on:click="billModalActive=true">請求先選択</b-button>
                                </td>
                              </template>
                              <template v-else>
                                <th class="disabled">請求先名称</th>
                                <td colspan="3">
                                  <input type="text" class="officeAreaTableInputLong" :value="getName(data.billingName, data.billingCode)" disabled placeholder="※得意先IDと異なるコードに売上を計上する場合は指定してください"/>
                                  <b-button class="is-primary withButton" v-on:click="billModalActive=true" disabled>請求先選択</b-button>
                                </td>
                              </template>
                            </tr>
                            <tr>
                              <th>担当営業員<span class="require"/></th>
                              <td colspan="3">
                                <input type="text" class="officeAreaTableInputLong" v-model="data.salesStaffName" disabled/>
                                <b-button  class="is-primary withButton" v-on:click="staffModalActive=true" >担当者選択</b-button>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <table style="margin-top:20px;">
                            <template v-for="(item, index) in data.estimateList">
                                <tr :key="index">
                                    <td>品目コード：<input type="text" style="width:100px;" v-model="item.code" disabled/></td>
                                    <td>品目名：<input type="text" style="width:450px;" v-model="item.name" disabled/></td>
                                    <td>見積りコード：<input type="text" style="width:150px;" v-model="item.estimateCode" maxlength="20"/></td>
                                </tr>
                            </template>
                        </table>
                        <b-button v-if="data.tempFlag" class="saveButton is-primary" @click="save">本登録</b-button>
                        <b-button v-else class="saveButton is-primary" @click="save">更新</b-button>
                    </div>
                </div>
            </template>
        </div>
        <b-modal :active.sync="staffModalActive" has-modal-card>
          <staffModal @select="setStaff"></staffModal>
        </b-modal>
        <b-modal :active.sync="customerModalActive" has-modal-card>
          <customerModal @select="setCustomer"></customerModal>
        </b-modal>
        <b-modal :active.sync="billModalActive" has-modal-card>
          <customerModal @select="setBill"></customerModal>
        </b-modal>
        <b-modal :active.sync="customerModalActive" has-modal-card>
            <customerModal @select="setCustomer"></customerModal>
        </b-modal>
        <b-modal :active.sync="billModalActive" has-modal-card>
            <customerModal @select="setBill"></customerModal>
        </b-modal>
        <b-modal :active.sync="customerModalActive" has-modal-card>
          <customerModal @select="setCustomer"></customerModal>
        </b-modal>
        <b-modal :active.sync="billModalActive" has-modal-card>
          <customerModal @select="setBill"></customerModal>
        </b-modal>
        <b-modal :active.sync="customerModalActive" has-modal-card>
            <customerModal @select="setCustomer"></customerModal>
        </b-modal>
        <b-modal :active.sync="billModalActive" has-modal-card>
            <customerModal @select="setBill"></customerModal>
        </b-modal>
    </div>
</template>
<script>

import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
import StaffSelectModal from "@/components/mock/philips/common/StaffSelectModal";
import CustomerSelectModal from "@/components/mock/philips/common/CustomerSelectModal";
export default {
  name: "DealerFacilitySetting",
  methods: {
    getName: function(name, code){
      if(name && code) return name + "（" + code + "）"
      return ""
    },
    Backward: function(){
        let index = this.facilityList.indexOf(this.selectedFacility);
        if(index == 0){
            index = this.facilityList.length - 1;
        } else {
            index = index -1;
        }
        this.selectedFacility = this.facilityList[index];
        this.getMaintenanceFacilityByEstimate(this.selectedFacility.facilityId);
    },
    Forward: function(){
        let index = this.facilityList.indexOf(this.selectedFacility);
        if(index == this.facilityList.length - 1){
            index = 0;
        } else {
            index = index + 1;
        }
        this.selectedFacility = this.facilityList[index];
        this.getMaintenanceFacilityByEstimate(this.selectedFacility.facilityId);
    },
    chengeSelect: function() {
        this.getMaintenanceFacilityByEstimate(this.selectedFacility.facilityId);
    },
    changeSalesOffice: function(){
        this.facilityList[this.facilityList.indexOf(this.selectedFacility)].office = this.data.office;
        this.selectedFacility.office = this.data.office;
    },
    save: function(){
      // Web Api Call
      let bodyparam = this.getCopy(this.data);
      if(!bodyparam.office){
        this.showErrorMessage("担当支店を設定してください。");
        return;
      }
      if(!bodyparam.salesOfficeCode){
        this.showErrorMessage("担当営業所(売上)を設定してください。");
        return;
      }
      if(!bodyparam.medicalInstitutionCode){
        this.showErrorMessage("得意先を設定してください。");
        return;
      }
      if(!bodyparam.salesStaffName){
        this.showErrorMessage("担当営業員を設定してください。");
        return;
      }
      if(!bodyparam.salesStaffId){
          bodyparam.salesStaffId = 0;
      }
      if(!bodyparam.salesOfficeCode){
          bodyparam.salesOfficeCode = "";
      }
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.setMaintenanceFacilityByEstimateUpdatePOST({
            body:bodyparam
          });
        },
        async function(result){
            await _this.getMaintenanceFacilityByEstimate(_this.selectedFacility.facilityId);
            _this.showSuccess(result)
        },
        function(result){
            _this.showErrorMessage(result);
        }
      );
    },
    back: function(){
      this.$router.push({
        name: "ExternalUserEdit",
        query: {uid:encodeURIComponent(this.uid), from:encodeURIComponent(this.from), }
      });
    },
    setStaff: function(staffInfo){
      if(staffInfo){
        this.data.salesStaffId = staffInfo.id;
        this.data.salesStaffName = staffInfo.name;
      }
    },
    setCustomer: function(customerInfo){
      if(customerInfo){
        this.data.medicalInstitutionCode = customerInfo.customerId;
        this.data.medicalInstitutionName = customerInfo.customerName;
        if(this.data.tempFlag){
          //本登録以前の施設の場合は、得意先コード変更に合わせて営業担当者も自動設定する
          this.setStaff({
            id: customerInfo.salesStaffId,
            name: customerInfo.salesStaffName,
          })
        }
      }
    },
    setBill: function(billingInfo){
      if(billingInfo){
         this.data.billingCode = billingInfo.customerId;
         this.data.billingName = billingInfo.customerName;
      }
    },
    getMaintenanceFacilityList: function(){
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.getMaintenanceFacilityListPOST({
            body:{
              belongId: _this.belongId
            }
          });
        },
        async function(result){
            _this.facilityList = result.obj;
            if(_this.facilityList.length > 0){
                _this.selectedFacility = _this.facilityList[0];
                await _this.getMaintenanceFacilityByEstimate(_this.selectedFacility.facilityId);
            }
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    getMaintenanceFacilityByEstimate: function(facilityId){
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.getMaintenanceFacilityByEstimatePOST({
            body:{
              facilityId: facilityId
            }
          });
        },
        function(result){
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    }
  },
  data() {
    var billingEnabled = false;  //検査解析請求先情報　非活性
    var uid = parseInt(this.$route.query["uid"],10);
    var from = this.$route.query["from"];
    var belongId = parseInt(this.$route.query["belongId"],10);
    var branchList = this.getBranchOfficeMaster();
    var salesOfficeMaster = this.getSalesOfficeMaster();
    salesOfficeMaster.unshift({});
    return {
        uid: uid,
        from: from,
        belongId:belongId,
        branchList:branchList,
        facilityList: null,
        selectedFacility: null,
        data : null,
        staffModalActive: false,
        customerModalActive: false,
        billModalActive: false,
        salesOfficeMaster:salesOfficeMaster,
        billingEnabled: billingEnabled
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar,      
    staffModal: StaffSelectModal,
    customerModal: CustomerSelectModal
  },
  mounted: async function(){
      await this.getMaintenanceFacilityList();
  }
};
</script>
<style lang="scss" scoped>
.postion-left {
    float:left;
    margin-left:10px;
}
.selectFacility {
    float:left;
    margin-top: 7px;
    margin-left:10px;
    width:400px;
}
.saveButton {
    margin-top:10px;
}
.fontSize20 {
    font-size: 20px;
}
.withButton {
  margin-left:10px !important;
  width:150px !important;
  height:29px !important;
}
.disabled {
  color: #7a7a7a;
}
#officeAreaTable {
  border-spacing:1px !important;
}
#officeAreaTable td select {
  width:95% !important;
}
.officeAreaTableInput {
  width:225px !important;
}
.officeAreaTableInputLong {
  width:800px !important;
}
#officeAreaTable th {
  width:150px !important;
}
#officeAreaTable td {
  vertical-align:middle !important;
  width:400px !important;
  padding-right:10px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/master/user/DealerFacilitySetting.vue